import CardDetailTracking from 'components/molecules/Card/Detail/Tracking';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as profileAC, getCoach, getWeight } from 'store/profile';
import {
	actionCreators,
	getInfoText,
	getIsDone,
	getIsUpdatingTracking,
	getMeasurement,
	getTitle,
} from 'store/programItems';
import { actionCreators as trackingAC } from 'store/trackingDescription';

const mapStateToProps = (state: any, ownProps: any) => {
	return {
		coach: getCoach(state),
		currentWeight: getWeight(state),
		title: getTitle(state, ownProps.id),
		infoText: getInfoText(state, ownProps.id),
		measurement: getMeasurement(state, ownProps.id),
		isDone: getIsDone(state, ownProps.id),
		isUpdatingTracking: getIsUpdatingTracking(state),
		inputWeight: {
			input: {
				type: 'text',
				name: 'body-weight',
				id: 'body-weight',
				maxLength: 256,
			},
		},
		inputWaist: {
			input: {
				type: 'text',
				name: 'body-circumference',
				id: 'body-circumference',
				maxlength: 256,
			},
		},
		inputBodyFat: {
			input: {
				type: 'text',
				name: 'body-fat',
				id: 'body-fat',
				maxlength: 256,
			},
		},
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...actionCreators,
			doLoadUserData: profileAC.doLoadUserData,
			doAddEvents: eventsAC.doAddEvents,
			doOpenDescription: trackingAC.doOpenDescription,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardDetailTracking as any);
